import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
    selector: 'ploeginfo',
    template: require('./ploeginfo.component.html'),
    styles: [require('./ploeginfo.component.css')]
})
export class PloegInfoComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }

    showModal(url: string){
        $('.modal-body').attr('src', url);
            (<any>$('#myModal')).modal({
                show: true
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/ploeginfo/ploeginfo.component.ts